module.exports = require("./ksh-DE.js");